<template>
  <div>
    <headers></headers>
    <div class="information-box">
      <p class="information-title">留言板</p>
      <el-form :model="dynamicValidateForm"  ref="ruleForm" class="demo-dynamic">
        <el-form-item
          prop="content"
          :rules="[
         { required: true, message: '请输入您要咨询的内容', trigger: 'blur' },
      ]"
          label="内容">
          <el-input   type="textarea" :rows="4" v-model="dynamicValidateForm.content"></el-input>
        </el-form-item>
        <el-form-item
          prop="name"
          :rules="[
         { required: true, message: '请输入姓名', trigger: 'blur' },
      ]"
          label="姓名">
          <el-input v-model="dynamicValidateForm.name"></el-input>
        </el-form-item>
        <el-form-item
          prop="phone"
          :rules="[
         { required: true, message: '请输入联系电话', trigger: 'blur' },
      ]"
          label="联系电话">
          <el-input v-model="dynamicValidateForm.phone"></el-input>
        </el-form-item>
        <el-form-item
          prop="email"
          label="邮箱">
          <el-input v-model="dynamicValidateForm.email"></el-input>
        </el-form-item>

        <el-form-item
          prop="email"
          label="地址">
          <el-input v-model="dynamicValidateForm.address"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn1" style="background:linear-gradient(135deg, #34E4AA 0%, #2C68FF 100%);border: 0" type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>

      </el-form>
    </div>
    <footers></footers>
  </div>
</template>


<script>
 import headers from "@/components/wap/header1";
 import footers from "@/components/wap/footer"
 import axios from "axios";
 export default {
   name:"information",
   components:{headers,footers},
   data(){
     return{
       dynamicValidateForm: {
         name:"",
         phone:"",
         email: '',
         address:"",
         content:""
       }
     }
   },
   mounted() {

   },
   methods:{
     submitForm(formName){
       this.$refs[formName].validate((valid) => {
         if (valid) {
           axios.post(this.pageUrl+`/leave-message`,this.dynamicValidateForm).then(res=>{
             this.$notify({
               type: 'success',
               title: '留言成功，感谢您的留言',
             });
           })
         } else {
           return false;
         }
       });
     }
   }
 }
</script>

<style>
  .information-box{
    padding: 0.5rem 0.2rem;
    box-sizing: border-box;
    font-size: 0.3rem;
    margin-top: 1rem;
  }
  .information-box .information-title{
    font-size: 0.5rem;
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.2rem;
  }
  .information-box .el-form-item__label{
    font-size: 0.36rem !important;
    font-weight: bold;
    color: #000000;
  }
  .information-box .el-form-item__error{
    font-size: 0.3rem !important;
  }
  .information-box .btn1{
    width: 100%;
    font-size: 0.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/information/index.vue